import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import queryString from 'query-string';
import { useRouter } from 'next/router';
import _ from 'lodash';

import { withTranslation } from 'language/i18n';
import filterMachinery from 'utils/filterMachinery';
import Layout from 'components/partials/Layout';
import Breadcrumb from 'components/Breadcrumb';
import MachineryList from 'components/machineryList/MachineryList';
import { getMachinery } from 'models/machinery';
import Filter from './components/machinery/Filter';
import Actions from './components/machinery/Actions';

const Machinery = ({
  t, machines, filters,
}) => {
  const router = useRouter();

  const [mobileFilterVisible, setMobileFilterVisible] = useState(false);
  const [selectedFilters, setSelectedFilters] = useState({});
  const [filtersFormRef, setFiltersFormRef] = useState();

  const breadcrumbs = [
    {
      label: t('homepage'),
      url: '/',
    },
    {
      label: t('machinery'),
      url: '/machinery',
    },
  ];

  useEffect(() => {
    if (!_.isEmpty(router.query)) {
      const routerQuery = router.query;
      _.forEach(Object.keys(routerQuery), (queryKey) => {
        const queryValue = routerQuery[queryKey];
        if (typeof queryValue === 'string') {
          routerQuery[queryKey] = [queryValue];
          filtersFormRef?.setFieldValue(`${queryKey}_${queryValue}`, true);
        } else if (Array.isArray((queryValue))) {
          queryValue.forEach((queryValueArrayItem) => {
            filtersFormRef?.setFieldValue(`${queryKey}_${queryValueArrayItem}`, true);
          });
        }
      });
      setSelectedFilters(routerQuery);
    }
  }, [router.query, filtersFormRef]);

  const onFilter = ({ name, value }) => {
    const newFilters = filterMachinery({
      name, value, oldFilters: selectedFilters, filtersFormRef,
    });
    router.push({
      pathname: '/machinery',
      query: newFilters,
    });
  };

  return (
    <main className="has-header">
      <div className="container">
        <div className="row mt-4 mb-4 mt-lg-3 mb-lg-3">
          <div className="col">
            <Breadcrumb links={breadcrumbs} />
          </div>
        </div>
        <div className="row mb-5">
          <Filter
            mobileVisible={mobileFilterVisible}
            setMobileVisible={setMobileFilterVisible}
            filters={filters}
            selectedFilters={selectedFilters}
            onFilter={onFilter}
            setFormRef={setFiltersFormRef}
          />
          <div className="col-15 col-lg-12">
            <Actions
              setMobileFilterVisible={setMobileFilterVisible}
              selectedFilters={selectedFilters}
              onFilter={onFilter}
              filters={filters}
            />
            <MachineryList machinery={machines} />
          </div>
        </div>
      </div>
    </main>
  );
};

Machinery.propTypes = {
  t: PropTypes.func,
  machines: PropTypes.array,
  filters: PropTypes.object,
};

export const getServerSideProps = async ({ query }) => {
  try {
    const qs = queryString.stringify(query, { arrayFormat: 'comma' });
    const { machines, filters } = await getMachinery(qs);

    const modifiedFilters = _.reduce(Object.keys(filters), (acc, val) => {
      const camelCaseVal = _.camelCase(val);
      acc[camelCaseVal] = _.map(Object.keys(filters[val]), (data) => {
        return { count: filters[val][data], selector: data };
      });
      return acc;
    }, {});

    return {
      props: {
        machines: machines || [],
        filters: modifiedFilters || [],
        blackHeader: true,
        headTitle: 'Makinalar',
      },
    };
  } catch (error) {
    return {
      props: {
        machines: [],
        filters: [],
        blackHeader: true,
        headTitle: 'Makinalar',
      },
    };
  }
};

Machinery.Layout = Layout;

export default withTranslation('common')(Machinery);
